import { FC, ButtonHTMLAttributes } from 'react'

import styled from 'styled-components'

import BoxIcon from 'src/Assets/Svg/Box.svg?react'

interface BoxButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  amount?: string
}

const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 48px;
  height: 48px;
  padding: 0;
  border-radius: 40px;
  border: ${({ theme }) => `1px solid ${theme.color.brandGreen}`};
  outline: none;
  cursor: pointer;
  background: ${({ theme }) => theme.color.brandGreen};
  box-shadow: ${({ theme }) => theme.shadow.header};
  transition:
    background-color 0.2s ease-in-out,
    border-color 0.2s ease-in-out,
    box-shadow 0.2s ease-in-out;

  svg path {
    fill: ${({ theme }) => theme.color.white};
    transition: fill 0.2s ease-in-out;
  }

  &:hover:not(:disabled) {
    box-shadow: none;
  }

  &:focus-visible {
    background: ${({ theme }) => theme.color.white};
    border-color: ${({ theme }) => theme.color.brandGreen};
    box-shadow: none;

    svg path {
      fill: ${({ theme }) => theme.color.brandGreen};
    }
  }

  &:active:not(:disabled) {
    background: ${({ theme }) => theme.color.darkGreen};
    border-color: ${({ theme }) => theme.color.darkGreen};
    box-shadow: none;
  }

  &:disabled {
    background: ${({ theme }) => theme.color.lightGrey};
    border-color: ${({ theme }) => theme.color.lightGrey};
    box-shadow: none;
    cursor: not-allowed;

    svg path {
      fill: ${({ theme }) => theme.color.white};
    }
  }
`

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  > svg {
    width: 16px;
    height: 16px;
  }
`

const BadgeContainer = styled.div`
  position: absolute;
  top: -2px;
  right: -2px;
  display: flex;
  align-items: center;
  justify-content: center;
`

const BadgeCircle = styled.div<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: ${({ theme, disabled }) =>
    disabled ? theme.color.mediumGrey : theme.color.mediumRed};
`

const BadgeText = styled.span`
  font-size: 12px;
  font-weight: 400;
  color: ${({ theme }) => theme.color.white};
  line-height: 150%;
`

export const BoxButton: FC<BoxButtonProps> = ({
  disabled,
  amount = '0',
  ...restProps
}) => (
  <Button disabled={disabled} {...restProps}>
    <IconWrapper>
      <BoxIcon />
    </IconWrapper>

    <BadgeContainer>
      <BadgeCircle disabled={disabled}>
        <BadgeText>{amount}</BadgeText>
      </BadgeCircle>
    </BadgeContainer>
  </Button>
)
